export default {"src":"/evde-internet/_next/static/media/red-tv.b7a06761.svg","height":32,"width":32};